module.exports = __webpack_public_path__ + "static/img/dd-target-icon-04.b30d29a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-target-icon-04.png
// module id = Z7n/
// module chunks = 1